<template>
  <div>
    <v-container fluid grid-list-xs py-0>
      <v-layout row wrap>
        <alert-dataset-editor-item v-for="(dataSet, key) in dataSetItems"
                                   :key="key" :data-set="dataSet"
                                   v-if="dataSet.visible && !dataSet.isDeleted"
                                   :data-set-key="key"
                                   :alert-id="alertId"
                                   :panel-colour="panelColour" :first-element="firstElement"/>
      </v-layout>
    </v-container>
    <v-container fluid grid-list-xs py-0>
      <v-layout row wrap>
        <alert-template-editor-item v-for="(emailTemplate, key) in emailTemplateItems"
                                    :key="key" :email-template="emailTemplate"
                                    v-if="emailTemplate.visible && !emailTemplate.isDeleted"
                                    :email-template-key="key"
                                    :alert-id="alertId"
                                    :panel-colour="panelColour"/>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
  import AlertDatasetEditorItem from './AlertDatasetEditorItem'
  import AlertTemplateEditorItem from './AlertTemplateEditorItem'

  export default {
    name: 'alert-details-body',
    components: {AlertTemplateEditorItem, AlertDatasetEditorItem},
    data () {
      return {}
    },
    props: ['panelColour', 'alertId'],
    computed: {
      bodySection () {
        return this.$vuetify.breakpoint.mdAndDown ? 'xs12' : 'xs9'
      },
      dataSetItems () {
        return this.$store.state.admin.newSingleAlert.dataSets
      },
      emailTemplateItems () {
        return this.$store.state.admin.newSingleAlert.emailTemplates
      },
      firstElement () {
        if (this.dataSetItems) {
          return this.dataSetItems.filter(el => !el.isDeleted).map(el => el.id)[0]
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertDetailsBody.vue